export default __webpack_public_path__ + "static/media/google_logo_only.1c81f39e.png";